import React from "react";
import { Link } from "react-router-dom";

const DashboardHome = ({ dashboards, custom, site }) => {
  return (
    <React.Fragment>
      <div className="row">
        <div className="col">
          <h3>Corporate Dashboards</h3>
          {dashboards.map((d) => (
            <Link key={d.DASHBOARD_ID} to={`/dashboards/${d.ADDRESS}`}>
              <button
                className={
                  d.TYPE === "C"
                    ? "btn btn-warning btn-lg m-1"
                    : "btn btn-primary btn-lg m-1"
                }
                disabled={
                  (d.TYPE === "C" && site.id !== "CO") ||
                  (d.TYPE === "S" && site.id === "CO")
                }
              >
                {d.DESCRIPTION}
              </button>
            </Link>
          ))}
        </div>
      </div>
      <div className="row">
        <div className="col">
          <h3>Custom Dashboards</h3>
          {custom.map((d) => (
            <Link key={d.DASHBOARD_ID} to={`/dashboards/${d.ADDRESS}`}>
              <button
                className={
                  d.SITE_TYPE === "C"
                    ? "btn btn-warning btn-lg m-1"
                    : "btn btn-primary btn-lg m-1"
                }
                disabled={
                  (d.SITE_TYPE === "C" && site.id !== "CO") ||
                  (d.SITE_TYPE === "S" && site.id === "CO")
                }
              >
                {d.DESCRIPTION}
              </button>
            </Link>
          ))}
        </div>
      </div>
    </React.Fragment>
  );
};

export default DashboardHome;
